import { render, staticRenderFns } from "./SDS-quality-widget.vue?vue&type=template&id=c2ba431a"
import script from "./SDS-quality-widget.vue?vue&type=script&lang=js"
export * from "./SDS-quality-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports